export default __webpack_public_path__ + "app/images/ic-18-clock-normal.svg";